type Props = {
    className?: string;
};

export function SortCarats({ className = '' }: Props) {
    return (
        <svg className={className} width="8" height="10" fill="none" viewBox="0 0 8 10">
            <g>
                <g>
                    <path
                        fill="#D0D5DD"
                        d="M4.231.5L1.454 3.875h5.554L4.23.5zM4.231 9.5l2.777-3.375H1.454L4.231 9.5z"
                    ></path>
                    <path
                        stroke="#D0D5DD"
                        strokeLinejoin="round"
                        strokeWidth="0.3"
                        d="M4.231.5L1.454 3.875h5.554L4.23.5zM4.231 9.5l2.777-3.375H1.454L4.231 9.5z"
                    ></path>
                </g>
            </g>
        </svg>
    );
}
